import { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useOpen from '../../../../components/hooks/useOpen';

import { sortPrecios } from '../../../../components/precios/util';
import { setArancelEdit } from '../../../../redux/actions/arancelActions';
import { useAranceles } from '../../../../swr/hooks/useAranceles';
import useMonedas from '../../../../swr/hooks/useMonedas';

const UseTratamientosAranceles = (arancel) => {
    const dispatch = useDispatch()
    const tratamiento = useSelector(state => state.arancel.editable);
    const { data: monedas } = useMonedas();
    const { data } = useAranceles();

    const [moneda, setMoneda] = useState(monedas[0].id_moneda)
    const [text, setText] = useState('');
    const modal = useOpen();

    const aranceles = useMemo(function () {
        const idArancel = arancel.idArancel;
        return data
            .map(arancel => ({
                ...arancel,
                idArancel: +arancel.idArancel,
                label: arancel.Tratamiento.toUpperCase(),
                moneda: monedas.find(item => item.id_moneda === arancel.id_moneda)
            }))
            .filter(item => item.idArancel === idArancel && (text.length ? item.label.includes(text) : true))
            .sort(sortPrecios)
    }, [text, monedas, arancel, data])

    const onChangeText = ({ target }) => setText(target.value.toUpperCase());
    const onChangeMoneda = (id) => setMoneda(id)

    // Modal tratamiento
    const onSelectTratamiento = (arancel) => {
        dispatch(setArancelEdit(arancel))
        modal.handleOpen();
    }
    const onCloseTratamiento = () => {
        dispatch(setArancelEdit(null))
        modal.handleClose();
    }

    return {
        text,
        modal,
        moneda,
        aranceles,
        tratamiento,
        onChangeText,
        onChangeMoneda,
        onSelectTratamiento,
        onCloseTratamiento
    }
}

export default UseTratamientosAranceles;